import { useRef } from 'react';

import { InsertDriveFileOutlined } from '@material-ui/icons';

import Button from '~/components/scales/Button/Button';

export default function UploadButton(props: {
  isDisabled?: boolean;
  onFileSelected: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  const { isDisabled: disabled = false, onFileSelected } = props;
  const fileInputRef = useRef<HTMLInputElement>(null);
  // Work around to allow a button to trigger a file input
  const onSelectBtnClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <>
      <Button
        data-cy="import-file-button"
        isDisabled={disabled}
        label="Select a File"
        onClick={onSelectBtnClick}
        startIcon={<InsertDriveFileOutlined />}
        type="secondary"
      />
      <input
        ref={fileInputRef}
        className="hidden"
        data-cy="import-file-input"
        onChange={onFileSelected}
        type="file"
      />
    </>
  );
}
